import React, { useState } from 'react'
import { MDBCol, MDBRow, MDBTooltip } from 'mdbreact';
import SubirImagenesContainer from '../../../SubirImagenes';
import { CloseSquare, Image2, } from 'react-iconly';
import { rutaImg } from '../../../../hooks/useValidarImagen';

const OpcionesGaleria = (props) => {
    const { type, id, handleEstilosComponente, styles } = props;

    const [modal, setModal] = useState(false)
    const [images, setImages] = useState(styles?.images || [])

    const modificarModal = () => {
        setModal(!modal)
    }

    const imagenActual = (img) => {
        const imagenesActuales = [
            ...images,
            {
                src: img.path,
                width: 3,
                height: 3
            }
        ]
        setImages(imagenesActuales)
        setModal(false)

        handleEstilosComponente({ type, id, valor: imagenesActuales, nombre: 'images' })

    }
    const removerImagen = (img) => {
        const imagenesActuales = images.filter(image => image.src != img)
        setImages(imagenesActuales)
        handleEstilosComponente({ type, id, valor: imagenesActuales, nombre: 'images' })
    }
    return (
        <div>
            <div className='mb-2'>
                <h4>Imagen</h4>
                <MDBRow className='mb-2'>
                    <MDBCol>
                        <div className='d-flex align-items-cente mb-2'>
                            <h6 className='m-0'>Subir Imagen</h6>
                            <a onClick={modificarModal}>
                                <Image2 className="ml-1" set="bold" />
                            </a>
                        </div>
                    </MDBCol>
                    {images.length > 0 ? <MDBCol className='border'>

                        {images.map(image => (
                            <div className='row '>
                                <div className='col-md-10 '>
                                    <p className='m-0 p-0' style={{
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden'
                                    }}>{image.src}</p>
                                </div>
                                <MDBTooltip
                                    domElement
                                    tag="span"
                                    placement="top"
                                >
                                    <span > <div className='col-m-2'>
                                        <a onClick={() => removerImagen(image.src)}>
                                            <CloseSquare className="ml-1" set="bold" />
                                        </a>
                                    </div> </span>
                                    <span> <img class="img-fluid" src={rutaImg + image.src} width={100} height={100} /></span>

                                </MDBTooltip>
                            </div>

                        ))}

                    </MDBCol>
                        :
                        null}
                </MDBRow>

            </div>
            <SubirImagenesContainer modal={modal} imagenActual={imagenActual} modificarModal={modificarModal} />
        </div>
    )
}

export default OpcionesGaleria